var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-sys-pagelet',_vm._g(_vm._b({ref:"wSysPagelet",attrs:{"id":"w-sys-page","type":"content","root":true}},'w-sys-pagelet',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }